import { cn } from '@ais-ui/utils';
import { Icons } from './Icons';

interface LoadingSpinnerProps {
  size?: 'big' | 'medium' | 'small';
  className?: string;
}

export const LoadingSpinner = ({ size, className }: LoadingSpinnerProps) => {
  let spinnerSize, textSize;
  switch (size) {
    case 'medium':
      spinnerSize = 'h-6 w-6';
      textSize = 'text-xl';
      break;
    case 'small':
      spinnerSize = 'h-4 w-4';
      textSize = 'text-lg';
      break;

    case 'big':
    default:
      spinnerSize = 'h-8 w-8';
      textSize = 'text-2xl';
      break;
  }
  return (
    <div
      className={cn('flex justify-center items-center h-full py-4', className)}
    >
      <Icons.spinner
        className={`text-primary ${spinnerSize} mr-4 animate-spin`}
      />
      <div className={`text-primary ${textSize}`}>Loading...</div>
    </div>
  );
};
